__turbopack_context__.v({
  "ProductCarouselItem": "_1VPeAW_ProductCarouselItem",
});
